import { motion } from "framer-motion";
import PageTransition from "../PageTransition/PageTransition";
import logo from "../../assets/img/logo.png";

import "./InfoPage.css";

const itemVariants = {
  hidden: {
    opacity: 0,
    y: 22,
    filter: "blur(8px)",
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
  },
};

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.13,
      delayChildren: 0.1,
    },
  },
};

function InfoPage({
  title,
  subtitle,
  text,
  children,
  footer = true,
  className = "",
}) {
  return (
    <PageTransition>
      <motion.section
        className={`info-page ${className}`}
        aria-label={title}
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.div className="info-page__brand" variants={itemVariants}>
          <header className="info-page__company">
            <span aria-hidden="true" />
            Ostrovskyi Company
          </header>

          <img className="info-page__logo" src={logo} alt="Oscomp logo" />
        </motion.div>

        <motion.h1 className="info-page__title" variants={itemVariants}>
          {title}
        </motion.h1>

        <motion.div
          className="info-page__divider"
          aria-hidden="true"
          variants={itemVariants}
        >
          <span />
        </motion.div>

        {subtitle && (
          <motion.h2 className="info-page__subtitle" variants={itemVariants}>
            {subtitle}
          </motion.h2>
        )}

        {text && (
          <motion.div className="info-page__text" variants={itemVariants}>
            {Array.isArray(text) ? (
              text.map((paragraph) => <p key={paragraph}>{paragraph}</p>)
            ) : (
              <p>{text}</p>
            )}
          </motion.div>
        )}

        {children && (
          <motion.div variants={itemVariants}>{children}</motion.div>
        )}

        {footer && (
          <motion.footer className="info-page__footer" variants={itemVariants}>
            <span>Excellence</span>
            <i />
            <span>Integrity</span>
            <i />
            <span>Global Perspective</span>
          </motion.footer>
        )}
      </motion.section>
    </PageTransition>
  );
}

export default InfoPage;
